import React, { useCallback, useState } from 'react';
import ChangeEmail, { ChangeEmailPayload } from '../components/login/ChangeEmail';
import services from '../services';
import RedirectIfLoggedIn from '../router/redirect/RedirectIfLoggedIn';
import ChangeEmailConfirmedPage from '../components/ChangeEmailConfirmedPage';
import { sleep } from '../utils/sleep';
import { notifyBugsnagHandledError } from '../utils/bugsnagClient';

const ChangeEmailPage: React.FC = () => {
  const [payload, setPayload] = useState<null | ChangeEmailPayload>(null);
  const [isResending, setIsResending] = useState(false);

  const handleChangeEmailSuccess = useCallback((payload: ChangeEmailPayload) => {
    setPayload(payload);
  }, []);

  const resendEmail = useCallback(async () => {
    if (payload) {
      setIsResending(true);
      try {
        await sleep(300);
        await services.user.changeEmail(payload.oldEmail, payload.newEmail, payload.password, payload.isLibraryUser);
      } catch (error) {
        notifyBugsnagHandledError(error as Error);
      } finally {
        setIsResending(false);
      }
    }
  }, [payload]);

  return (
    <RedirectIfLoggedIn>
      {payload
        ? <ChangeEmailConfirmedPage
          newEmail={payload.newEmail}
          resendEmail={resendEmail}
          changeEmailAddress={() => setPayload(null)}
          isLoading={isResending}
        />
        : <ChangeEmail onChangeEmailSuccess={handleChangeEmailSuccess}></ChangeEmail>
      }
    </RedirectIfLoggedIn>
  );
};

export default ChangeEmailPage;
